import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { ReturnProtectionIcon, Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const ReturnProtectionInfo = ({ message }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  return (
    <Styles.MainContainer>
      <Styles.Header>
        <ReturnProtectionIcon size={16} />
        <Text type="titleS">{t('Return Protection')}</Text>
      </Styles.Header>
      <Text type="bodyMRegular" color={theme.colors.text.muted}>
        {message}
      </Text>
    </Styles.MainContainer>
  )
}

export default ReturnProtectionInfo
